<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-book-open text-primary"></i> Subject</h5>
      </div>
      <hr />
      <div class="row g-3">
            <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.clsID)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            </div>
       <div class="col-md-3">
        <label class="form-label"> Name<sup><span class="text-danger font-12">*</span></sup> : </label>
        <input type="text" class="form-control form-control-sm" list="nameList" v-model="Obj.name" />
        <datalist id="nameList">
          <option v-for="(item, index) in nameOptions" :key="index" :value="item"></option>
        </datalist>
      </div>
        <div class="col-md-3">
          <label class="form-label">Type<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.type">
            <option selected=""></option>
            <option value="Theory">Theory</option>
            <option value="Pratical">Pratical</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Code :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.code" />
        </div>
        <div class="col-md-12 text-end mt-1">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
       <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="row">
        <div class="col-md-12 table-responsive mt-2">
             <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
          <DataTable v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.name" @delRecord="delRecord" @closeModal="delObj.name = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted, computed} from 'vue'
import { schoolStore } from '@/utils/schoolStore';
const { clsList, uniqueClsList } = schoolStore();
const  Obj = ref( {clsID:"", name: "", type: "", code: "", })
const   msgObj= ref({ msg: "", role: "", show: false, })
const   delObj = ref({})
const   errors= ref({})
const nameOptions = computed(() =>
  rows.value .map(r => r.name?.trim()) .filter( (name, index, arr) =>
   name && index === arr.findIndex(n => n?.trim().toLowerCase() === name.toLowerCase()) ) .sort((a, b) => a.localeCompare(b)) );

const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Name', key: 'name' },
  { label: 'Class', key: 'clsName' },
  { label: 'Type', key: 'type' },
  { label: 'Code', key: 'code' }
]);
const handleEdit = (row) => {
    Obj.value = { ...row }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
const save = async() => {
      const fields = {
        Class: { value: Obj.value.clsID, validators: [isRequired], },
        Name: { value: Obj.value.name, validators: [isRequired], },
        Type: { value: Obj.value.type, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
       const isDuplicate = rows.value.some(
      (item) =>
        item.clsID === Obj.value.clsID &&
        item.name.trim().toLowerCase() === Obj.value.name.trim().toLowerCase() &&
        (!Obj.value._id || item._id !== Obj.value._id)
    );

    if (isDuplicate) {
      msgObj.value = {
        msg: "Subject already exists for this class.",
        role: "danger",
        show: true,
      };
      return;
    }
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/sub${url}`, Obj.value)
          .then((response) => {
            reset();
            msgObj.value = { msg: `Subject ${msg} Successfuly`, role: "success", show: true, };
            loadData();
            console.log(response);
          })
          .catch((error) => { console.log(error); });
      }
    }
    const reset= async() => {
      Obj.value = { clsID:"", name: "", type: "", code: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value = {};
    }
     const progress = ref(0)
    const loadData = async () => {
  let direction = 1;
  let progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);
  await api.get('/sub/all').then((response) => {
    const clsMap = new Map(clsList.value.map(c => [c._id, c.name]));
    rows.value = response.data .map((item) => ({ ...item, clsName: clsMap.get(item.clsID) || '', }))
      .sort((a, b) => a.clsName.localeCompare(b.clsName, undefined, { numeric: true }))
      .map((item, i) => ({ ...item, Sno: i + 1, }));
    progress.value = 0;
    clearInterval(progressInterval);
  });
};
    const delRecord= async() => {
      await api.delete(`/sub/${delObj.value._id}`)
        .then(() => {
          delObj.value={};
          loadData();
          msgObj.value = { msg: "Subject Deleted Successfuly.", role: "danger", show: true, };
        });
    }
     onMounted(() => { loadData() })
</script>
<style>

.scrollable-menu {
  max-height: 10rem; 
  overflow-y: auto;
}
.dropdown-a{
  border: 1px solid #bebaba87 !important;
  height:29px !important;
  text-align: left !important;
}
</style>